module.exports = __webpack_public_path__ + "img/password.9173da92.svg";